$menuWidthSizes: 300, 400, 560;

@each $size in $menuWidthSizes {
  :host([menuWidth='#{$size}']) {
    .side-menu {
      width: #{$size}px;
    }
  }
}

:host {
  position: absolute;
  display: none;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}

:host([menuPosition='right']) {
  .side-menu {
    right: 0;
    box-shadow: -4px 0px 6px var(--chart-050-hover);
  }
}

:host([menuPosition='left']) {
  .side-menu {
    left: 0;
    box-shadow: 4px 0px 6px var(--chart-050-hover);
  }
}

.side-menu {
  position: absolute;
  height: 100%;
  top: 0;
  bottom: 0;
  background-color: var(--white-layout-303-level-2-elevation);

  &--content {
    height: 100%;
    overflow: auto;
  }

  &--button {
    position: absolute;
    height: 24px;
    right: calc(2 * var(--spacer));
    top: calc(2 * var(--spacer));
    z-index: 1050;
    height: auto;
  }
}

:host([isOpen]) {
  display: block;
}

:host([resizable]) {
  .side-menu {
    .resize-handler {
      position: absolute;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: col-resize;
      width: calc(var(--spacer) * 4);
      .resize-icon {
        position: absolute;
        transition: all 0.3s ease;
        color: var(--chart-300-icon-buttons);
        font-size: 20px;
      }
      &:hover {
        fill: var(--blue-layout-400-primary);
        .resize-icon::part(svgIcon) {
          fill: var(--blue-layout-400-primary) !important;
        }
      }
    }
  }
}

:host([resizable='left']) {
  .resize-handler {
    left: -16px;
    &:after {
      left: 10px;
    }
    .resize-icon {
      left: 12px;
    }
  }
}

:host([resizable='right']) {
  .resize-handler {
    right: -16px;
    &:after {
      right: 10px;
    }
    .resize-icon {
      right: 12px;
    }
  }
}

@media screen and (min-width: 1920px) {
  :host([isResponsive]) {
    .side-menu {
      min-width: 30vw;
    }
  }
}
